import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ArrowRightIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-16 pb-20 overflow-hidden md:pt-28 md:pb-28 bg-beige" data-id="element-34">
      <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8" data-id="element-35">
        <div className="grid items-center grid-cols-1 gap-12 md:grid-cols-2 md:gap-20" data-id="element-36">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="order-1 text-center md:text-left" data-id="element-37">
            <div className="inline-flex items-center px-4 py-2 mb-8 text-sm font-semibold tracking-wide rounded-full text-sage-dark bg-sage-light/30" data-id="element-38">
              Sistema de 30 Días
            </div>

            <h1 className="mb-6 text-4xl font-extrabold leading-[1.15] tracking-tight text-charcoal sm:text-4xl md:text-5xl lg:text-6xl font-playfair" data-id="element-39">
              Recupera el Control de Tu Vida en{' '}
              <span className="text-sage" data-id="element-40">10 Minutos al Día</span>
            </h1>

            <p className="mb-10 text-lg leading-relaxed text-charcoal/80 md:text-xl max-w-lg mx-auto md:mx-0" data-id="element-41">
              Un sistema simple para mamás ocupadas que no tienen tiempo para
              rutinas imposibles.
            </p>

            {/* Ebook Image — MOBILE ONLY */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.92
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.9,
            delay: 0.15,
            ease: 'easeOut'
          }} className="flex justify-center mb-12 md:hidden" data-id="element-42">
              <img src="https://cdn.magicpatterns.com/uploads/rnckHxjYNHWzdxwLiQSRQM/Gemini_Generated_Image_rq7jc1rq7jc1rq7j_cleanup.png" alt="Ebook Organiza Tu Vida en 10 Minutos al Día" className="w-full max-w-md drop-shadow-2xl" data-id="element-43" />
            </motion.div>

            <div className="mb-10 space-y-4" data-id="element-44">
              {['Sin rutinas imposibles.', 'Sin levantarte a las 5 AM.', 'Sin sentirte culpable todo el tiempo.'].map((item, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -20
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              delay: 0.4 + index * 0.1,
              duration: 0.5
            }} className="flex items-center justify-center md:justify-start text-charcoal/90" data-id="element-45">
                  <div className="flex items-center justify-center flex-shrink-0 w-6 h-6 mr-3 rounded-full bg-warm-green/15" data-id="element-46">
                    <CheckIcon className="w-4 h-4 text-warm-green" data-id="element-47" />
                  </div>
                  <span className="font-medium text-lg" data-id="element-48">{item}</span>
                </motion.div>)}
            </div>

            <div className="flex flex-col items-center md:items-start gap-5" data-id="element-49">
              <motion.a href="https://flz0kwq3a7pdvbu3-73373384873.shopifypreview.com/products_preview?preview_key=c7e0a76a09e911c574d938c9b20fe58e" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} animate={{
              boxShadow: ['0 0 0 0 rgba(139, 168, 137, 0.4)', '0 0 0 12px rgba(139, 168, 137, 0)', '0 0 0 0 rgba(139, 168, 137, 0)']
            }} transition={{
              boxShadow: {
                duration: 2,
                repeat: Infinity,
                ease: 'easeInOut'
              }
            }} className="inline-flex items-center justify-center w-full px-8 py-5 text-lg font-bold text-white transition-all rounded-full sm:w-auto bg-sage hover:bg-sage-dark shadow-lg shadow-sage/30 hover:shadow-sage/50" data-id="element-50">
                QUIERO ORGANIZAR MI VIDA AHORA
                <motion.span animate={{
                x: [0, 5, 0]
              }} transition={{
                duration: 1.2,
                repeat: Infinity,
                ease: 'easeInOut'
              }} data-id="element-51">
                  <ArrowRightIcon className="w-5 h-5 ml-2" data-id="element-52" />
                </motion.span>
              </motion.a>

              <p className="text-sm text-charcoal/50 font-medium tracking-wide" data-id="element-53">
                Acceso inmediato • Pago único • Sin suscripción
              </p>
            </div>
          </motion.div>

          {/* Ebook Image — DESKTOP ONLY */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.9,
          delay: 0.2,
          ease: 'easeOut'
        }} className="items-center justify-center order-2 hidden md:flex" data-id="element-54">
            <img src="https://cdn.magicpatterns.com/uploads/rnckHxjYNHWzdxwLiQSRQM/Gemini_Generated_Image_rq7jc1rq7jc1rq7j_cleanup.png" alt="Ebook Organiza Tu Vida en 10 Minutos al Día" className="w-full max-w-md drop-shadow-2xl" data-id="element-55" />
          </motion.div>
        </div>
      </div>
    </section>;
}